let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fH82G")).then(() => parcelRequire('9c5wb'));